import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Column, Row } from '../../../models/table';
import { TableAbstractComponent } from '../table.abstract.component';
import { MatRipple } from '@angular/material/core';
import { Liability } from '../../../../liabilities/models/liability.model';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';
import { SafeHtmlPipe } from '../../../utils/pipes/safe-html.pipe';
import { MatCheckbox } from '@angular/material/checkbox';
import { ExpandedDetailComponent } from '../expanded-detail/expanded-detail.component';
import { MatIconButton } from '@angular/material/button';
import { DefaultLayoutDirective } from 'ng-flex-layout';
import { DeviceService } from '../../../services/device.service';


@Component({
  standalone: true,
  selector: 'app-mobile-table',
  templateUrl: './mobile.table.component.html',
  styleUrls: ['./mobile.table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  imports: [MatTableModule, CommonModule, IconComponent, SafeHtmlPipe, MatCheckbox, ExpandedDetailComponent, MatIconButton, DefaultLayoutDirective],

})
export class MobileTableComponent<T extends Row> extends TableAbstractComponent<T> implements OnInit {

  @Input()
  public rowStyle: (row: T) => any;

  @Input()
  public showInformation: boolean;
  @Input() public hideHeader: boolean;
  @Input() public startedPaymentId: string;
  @Output() public liabilityMarkedAsPaidEvent = new EventEmitter<void>();
  @ViewChild(MatRipple) public ripple: MatRipple;
  private _liability: Liability;
  public get liability(): Liability {
    return this._liability;
  }

  public columnsMobileNames = [];
  public headerColumnNames = [];
  public columnsMobile: Map<string, Column[]> = new Map();

  constructor(public deviceService: DeviceService) {
    super();
  }

  ngOnInit(): void {
    let columns = this.columns.filter(it => !it.hideOnMobile);
    let min = columns[0].mobileViewDetails.column;
    let max = min;
    columns.forEach(value => {
      if (value.mobileViewDetails.column < min) {
        min = value.mobileViewDetails.column;
      }
      if (value.mobileViewDetails.column > max) {
        max = value.mobileViewDetails.column;
      }
    });
    for (let k = min; k <= max; k++) {
      let columnsInTd = columns
        .filter(value => value.mobileViewDetails.column === k)
        .sort((a, b) => a.mobileViewDetails.row - b.mobileViewDetails.row);
      this.columnsMobile.set(k.toString(), columnsInTd);
    }
    this.columnsMobileNames = Array.from(Object(this.columnsMobile).keys());
    if (this.isSelectable) {
      this.columnsMobileNames = ['checkboxSelect', ...this.columnsMobileNames];
      if (!this.multiselectDisabled) {
        this.headerColumnNames = ['checkboxSelect'];
      }
    }
    if (this.showInformation) {
      this.headerColumnNames.push('1');
    }
    if (this.isExpandable) {
      this.columnsMobileNames = [...this.columnsMobileNames, 'expanded'];
    }

  }

  get columnEntries() {
    return Array.from(this.columnsMobile.entries());
  }

  getStyles(column: any, element: any) {
    const screenWidth = window.innerWidth;
    const styles: any = {
      'width': '100%',
      'overflow': 'visible',
      'inline-size': '100%',
      'max-width': screenWidth <= 600
        ? column.sMaxWidth || null
        : column.mMaxWidth || null
    };

    if (column.mobileStyle !== undefined) {
      Object.assign(styles, column.mobileStyle(element));
    }
    return styles;
  }

  isApple(){
    return  this.deviceService.isIOS();
  }
}
